import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/components/pages/home/login';
import ForgotPassword from '@/components/pages/home/forgot-password';
import ValidateCode from '@/components/pages/home/forgot-password/validate-code';
import ChangePassword from '@/components/pages/home/forgot-password/change-password';
import ExpiredPassword from '@/components/pages/home/forgot-password/expired-password';
import TwoFactor from '@/components/pages/home/authentication/two-factor';
import NotFound from '@/components/pages/not-found';
import Authentication from '@/components/pages/home/authentication';
import Dashboard from '@/components/pages/dashboard';
import dashboardPage from '@/components/organisms/dashboard';
import NewAction from '@/components/organisms/actions/select-metric';
import StepOne from '@/components/organisms/actions/step-one';
import StepTwo from '@/components/organisms/actions/step-two';
import StepThree from '@/components/organisms/actions/step-three';
import actionList from '@/components/organisms/action-list';
import actionListDetails from '@/components/organisms/action-list/action-list-details';
import Treatments from '@/components/organisms/treatments';
import SeparatedTreatments from '@/components/organisms/treatments/separated-treatments';
import TreatmentsRevision from '@/components/organisms/treatments/treatments-revision';
import CloseTheLoop from '@/components/organisms/closetheloop';
import treatmentDetails from '@/components/organisms/treatments/treatment-details';
// eslint-disable-next-line
import Settings from '@/components/organisms/settings';
// eslint-disable-next-line
import SettingsAdminAccess from '@/components/organisms/settings';
import Preview from '@/components/pages/preview';
import Answers from '@/components/organisms/answers';
import researchPage from '@/components/pages/research-page';
import researchPageTotem from '@/components/pages/research-page-totem';
import researchPageQrCode from '@/components/pages/research-page-qrcode';
import Reports from '@/components/organisms/reports';
import PowerBi from '@/components/organisms/reports/power-bi';
import AIAnalysis from '@/components/organisms/reports/ai-analysis';
import AISwotReports from '@/components/organisms/reports/ai-analysis/ai-swot-reports';
import SwotView from '@/components/organisms/reports/ai-analysis/ai-swot-reports/swot-view';
import AISummarizationReports from '@/components/organisms/reports/ai-analysis/ai-summarization-reports';
import SummarizationView from '@/components/organisms/reports/ai-analysis/ai-summarization-reports/summarization-view';
import Manual from '@/components/organisms/manual';
import Sentiment from '@/components/organisms/sentiment';
import Resend from '@/components/organisms/resend';
import ResendWpp from '@/components/organisms/resendwpp';
import Clients from '@/components/organisms/clients';
import Trash from '@/components/organisms/trash';
import Unsubscribe from '@/components/pages/unsubscribe-email';
import Master from '@/components/organisms/master';
import ActionGroup from '@/components/organisms/action-group';
import Download from '@/components/organisms/download';
import Upload from '@/components/organisms/upload';
import LoginCompany from '@/components/pages/home/login-company';
import Reminders from '@/components/organisms/reminders';
import Schedulings from '@/components/organisms/scheduling';
import SSO from '@/components/pages/home/sso';
import INDECX from '@/components/pages/home/sso/indecx';
import EMBRACON from '@/components/pages/home/sso/embracon';
import TENDA from '@/components/pages/home/sso/tenda';
import GETNET from '@/components/pages/home/sso/getnet';
import LTM from '@/components/pages/home/sso/ltm';
import ENJOEI from '@/components/pages/home/sso/enjoei';
import TRIBANCO from '@/components/pages/home/sso/tribanco';
import SINQIA from '@/components/pages/home/sso/sinqia';
import UNICRED from '@/components/pages/home/sso/unicred';
import PWC from '@/components/pages/home/sso/pwc';
import CGONE from '@/components/pages/home/sso/cgone';
import MRV from '@/components/pages/home/sso/mrv';
import JUNTO from '@/components/pages/home/sso/junto';
import SSOConfirmLogin from '@/components/pages/home/sso/confirm-login';
import integrationZeenvia from '@/components/organisms/settings/integrations-webhooks/integration-zeenvia';
import integrationKeyApi from '@/components/organisms/settings/integrations-webhooks/integration-api';
import webhookCollectResponse from '@/components/organisms/settings/integrations-webhooks/collect-response';
import webhookCollectShoot from '@/components/organisms/settings/integrations-webhooks/collect-shoot';
import Widget from '@/components/pages/widget';
import GenerateQrCode from '@/components/organisms/actions/prepare-qr-code';
import AllGenerateQrCode from '@/components/organisms/actions/generate-all-qr-code';
import StepThreeLink from '@/components/organisms/actions/step-three-link';
import Quarentines from '@/components/organisms/quarentines';
import Blacklist from '@/components/organisms/blacklist';
import Categorization from '@/components/organisms/categorization';
import CategorizationAdicional from '@/components/organisms/categorization-additional';
import SSOError from '@/components/pages/sso-error';
import SSOListCompanies from '@/components/pages/home/sso/list-companies';
import Panels from '@/components/organisms/panels';
import CallCenter from '@/components/organisms/call-center';
import Redirect from '@/components/pages/home/redirect';

Vue.use(Router);

export default new Router({
  mode: 'history',
  history: true,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
    },
    {
      path: '/redirect/:token',
      name: 'Redirect',
      component: Redirect,
      props: true,
    },
    {
      path: '/mercedes-benz',
      name: 'Login Mercerdes Benz',
      component: LoginCompany,
    },
    {
      path: '/profile-admin-access',
      name: 'Perfil de Acesso',
      component: SettingsAdminAccess,
    },
    {
      path: '/boticario',
      name: 'Login Boticario',
      component: LoginCompany,
    },
    {
      path: '/login',
      name: 'Entrar',
      component: Login,
    },
    {
      path: '/forgot-password',
      name: 'Recuperar Senha',
      component: ForgotPassword,
    },
    {
      path: '/validate-code',
      name: 'Validar Código',
      component: ValidateCode,
    },
    {
      path: '/change-password',
      name: 'Trocar Senha',
      component: ChangePassword,
    },
    {
      path: '/two-factor',
      name: 'Two Factor',
      component: TwoFactor,
      props: true,
    },
    {
      path: '/expired-password',
      name: 'Senha Expirada',
      component: ExpiredPassword,
      props: true,
    },
    {
      path: '/sso/:userId/:tokenId',
      name: 'Single Sign-On',
      component: SSO,
    },
    {
      path: '/indecx',
      name: 'Login IndeCX',
      component: INDECX,
    },
    {
      path: '/embracon',
      name: 'Login Embracon',
      component: EMBRACON,
    },
    {
      path: '/tenda',
      name: 'Login Tenda',
      component: TENDA,
    },
    {
      path: '/getnet',
      name: 'Login Getnet',
      component: GETNET,
    },
    {
      path: '/ltm',
      name: 'LTM',
      component: LTM,
    },
    {
      path: '/enjoei',
      name: 'Login Enjoei',
      component: ENJOEI,
    },
    {
      path: '/tribanco',
      name: 'Login Tribanco',
      component: TRIBANCO,
    },
    {
      path: '/sinqia',
      name: 'Login Sinqia',
      component: SINQIA,
    },
    {
      path: '/unicred',
      name: 'Login Unicred',
      component: UNICRED,
    },
    {
      path: '/pwc',
      name: 'Login PwC',
      component: PWC,
    },
    {
      path: '/cgone',
      name: 'Login CGONE',
      component: CGONE,
    },
    {
      path: '/mrv',
      name: 'Login MRV',
      component: MRV,
    },
    {
      path: '/junto',
      name: 'Login JUNTO',
      component: JUNTO,
    },
    {
      path: '/sso-confirm-login/:ssoType/:token',
      name: 'Confirmar login SSO',
      component: SSOConfirmLogin,
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound,
    },
    {
      path: '*',
      redirect: '/404',
    },
    {
      path: '/authentication',
      name: 'Authentication',
      component: Authentication,
    },
    {
      path: '/dashboard/:companyId?',
      component: Dashboard,
      children: [
        {
          path: '/',
          name: 'Dashboard',
          component: dashboardPage,
        },
        {
          path: '/call-center',
          name: 'Módulo telefônico',
          component: CallCenter,
        },
        {
          path: '/new-action',
          name: 'Nova ação',
          component: NewAction,
        },
        {
          path: '/action/layout/:id',
          name: 'Edit Action Layout',
          component: StepOne,
        },
        {
          path: '/action/config/:id',
          name: 'Edit Action Config',
          component: StepTwo,
        },
        {
          path: '/action/importation/:id',
          name: 'Action Importation',
          component: StepThree,
        },
        {
          path: '/action/prepare-qr-code/:id',
          name: 'Generate Qr Code',
          component: GenerateQrCode,
        },
        {
          path: '/action/generate-all-qr-code/:id',
          name: 'Generate All Qr Code',
          component: AllGenerateQrCode,
        },
        {
          path: '/action/link/:id',
          name: 'StepThreeLink',
          component: StepThreeLink,
        },
        {
          path: '/answers',
          name: 'Respostas',
          component: Answers,
        },
        {
          path: '/action-list',
          name: 'Lista de Ações',
          component: actionList,
        },
        {
          path: '/action-list/:id',
          name: 'Detalhes da Ação',
          component: actionListDetails,
        },
        {
          path: '/treatments',
          name: 'Tratativas',
          component: Treatments,
        },
        {
          path: '/separated-treatments',
          name: 'Tratativas separadas',
          component: SeparatedTreatments,
        },
        {
          path: '/treatments-revision',
          name: 'revisão de Tratativas',
          component: TreatmentsRevision,
        },
        {
          path: '/treatments/:id',
          name: 'Detalhes da tratativa',
          component: treatmentDetails,
        },
        {
          path: '/close-the-loop',
          name: 'Close the loop',
          component: CloseTheLoop,
        },
        {
          path: '/settings',
          name: 'Configurações',
          component: Settings,
        },
        {
          path: '/users',
          name: 'Usuários',
          component: Settings,
        },
        {
          path: '/categories',
          name: 'Categorias',
          component: Settings,
        },
        {
          path: '/branches',
          name: 'Filiais',
          component: Settings,
        },
        {
          path: '/integrations',
          name: 'Integrações/Webhooks',
          component: Settings,
        },
        {
          path: '/integrations/zeenvia',
          name: 'Integração Zeenvia',
          component: integrationZeenvia,
        },
        {
          path: '/integrations/api-key',
          name: 'Chave de Integração Via API',
          component: integrationKeyApi,
        },
        {
          path: '/integrations/collect-response',
          name: 'Webhook - Coleta de resposta',
          component: webhookCollectResponse,
        },
        {
          path: '/integrations/collect-shoot',
          name: 'Webhook - Coleta de resposta',
          component: webhookCollectShoot,
        },
        {
          path: '/profile-access',
          name: 'Perfil de Acesso',
          component: Settings,
        },
        {
          path: '/alerts-bulletins',
          name: 'Alertas/Boletim',
          component: Settings,
        },
        {
          path: '/companies',
          name: 'Empresas',
          component: Settings,
        },
        {
          path: '/master',
          name: 'Configurações Master',
          component: Master,
        },
        {
          path: '/reports',
          name: 'Relatórios',
          component: Reports,
        },
        {
          path: '/powerbi',
          name: 'PowerBI',
          component: PowerBi,
        },
        {
          path: '/aianalysis',
          name: 'AIAnalysis',
          component: AIAnalysis,
        },
        {
          path: '/aiswotreports',
          name: 'AISwotReports',
          component: AISwotReports,
        },
        {
          path: '/aisummarizationreports',
          name: 'AISummarizationReports',
          component: AISummarizationReports,
        },
        {
          path: '/manual',
          name: 'Manual',
          component: Manual,
        },
        {
          path: '/sentiment',
          name: 'Sentimento',
          component: Sentiment,
        },
        {
          path: '/categorization',
          name: 'Categorização',
          component: Categorization,
        },
        {
          path: '/categorization-additional',
          name: 'Categorização Adicional',
          component: CategorizationAdicional,
        },
        {
          path: '/resend',
          name: 'Resend',
          component: Resend,
        },
        {
          path: '/resendwpp',
          name: 'Whatsapp',
          component: ResendWpp,
        },
        {
          path: '/clients',
          name: 'Clients',
          component: Clients,
        },
        {
          path: '/trash',
          name: 'Lixeira',
          component: Trash,
        },
        {
          path: '/action-group',
          name: 'Grupo de Ações',
          component: ActionGroup,
        },
        {
          path: '/downloads',
          name: 'downloads',
          component: Download,
        },
        {
          path: '/uploads',
          name: 'uploads',
          component: Upload,
        },
        {
          path: '/reminders',
          name: 'Reminders',
          component: Reminders,
        },
        {
          path: '/scheduling',
          name: 'Schedulings',
          component: Schedulings,
        },
        {
          path: '/quarentines',
          name: 'Quarentines',
          component: Quarentines,
        },
        {
          path: '/blocklist',
          name: 'Blocklist',
          component: Blacklist,
        },
        {
          path: '/panels',
          name: 'Panels',
          component: Panels,
        },
        {
          path: '/swot-view/:id',
          name: 'View Swot',
          component: SwotView,
        },
        {
          path: '/summarization-view/:id',
          name: 'View Summarization',
          component: SummarizationView,
        },
      ],
    },
    {
      path: '/email/preview',
      name: 'Preview',
      component: Preview,
    },
    {
      path: '/pesquisa/:token/:grade?',
      name: 'Research Page',
      component: researchPage,
    },
    {
      path: '/survey-qrcode/:actionId/:grade?',
      name: 'QRCode Research Page',
      component: researchPageQrCode,
    },
    {
      path: '/survey-link/:actionId/:grade?',
      name: 'Link Research Page',
      component: researchPageQrCode,
    },
    {
      path: '/survey-totem/:actionId/:grade?',
      name: 'Link Research Page',
      component: researchPageTotem,
    },
    {
      path: '/widget/:actionId/:inviteId',
      name: 'Widget',
      component: Widget,
    },
    {
      path: '/unsubscribe/:inviteId',
      name: 'Desinscrever',
      component: Unsubscribe,
    },
    {
      path: '/sso-error',
      name: 'SSOError',
      component: SSOError,
    },
    {
      path: '/list-companies/:userId',
      name: 'SSOListCompanies',
      component: SSOListCompanies,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js